export const firmaElectronicaTypes = {
  show_password: "[Firma Electronica] mostrar/ocultar password",
  add_cert_file: "[Firma Electronica] agregar archivo .cer",
  add_key_file: "[Firma Electronica] agregar archivo .key",
  add_tipo_firmante: "[Firma Electronica] agregar tipo firmante",
  loading_firma: "[Firma Electronica] loading firma electronica",
  add_password: "[Firma Electronica] Add Password firma electronica",
  reset_state_success:
    "[Firma Electronica] Reset state firma electronica success ",
  reset_state_error: "[Firma Electronica] reset state firma electronica error",
  add_error_messages: "[Firma Electronica] agregar mensajes a los errores",
  add_str_certificate: "[Firma Electronica] agregar certificado",
  add_digestiones: "[Firma Electronica] agregar digestiones",
  add_str_cert_pem: "[Firma Electronica] agregar cer pem",
  add_str_private_key: "[Firma Electronica] agregar str llave privada",
  add_o_private_key: "[Firma Electronica] agregar o private key",
  add_status_firma: "[Firma Electronica] agregar status firma",
  add_der_response_data: "[Firma Electronica] agreagar response service der",
  add_vector_response_data: "[Firma Electronica] agregar response vector data",
  add_algoritmo_digestion: "[Firma Electronica] agregar algoritmo digestion",
  add_iteraciones_encontradas:
    "[Firma Electronica] agregar iteraciones encontradas",
  show_cer_key_save: "[Firma Electronica] ver certificados guardados",
  show_certificados_guardados:
    "[Firma Electronica] mostrar certificados guardados",
  is_success_firmado:
    "[Firma Electronica] se ha firmado la referencia satisfactoriamente",
  add_list_firmantes: "[Firma Electronica] agregar lista firmantes",
  cer_selected: "[Firma Electronica] agregar base 64 certificado seleccionado",
  key_selected: "[Firma Electronica] agregar base 64 key seleccionado",
  change_step_firma:
    "[Firma Electronica] cambiar pasos completados para firmar correctamente",
};
